module.exports = __webpack_public_path__ + "static/media/enhanced.da47aaf2.svg";